import {
  setAccessTokenToLocalStorage,
  setRefreshTokenToLocalStorage,
  setUserData,
} from 'ducks/user';
import * as React from 'react';
import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { createProfile } from 'services/clients/user';

export const useCreateProfile = (proceed: (email: string) => void) => {
  const dispatch = useDispatch();

  const mutation = useMutation(createProfile);

  React.useEffect(() => {
    if (mutation.isSuccess && mutation.data) {
      const { access_token: accessToken, refresh_token: refreshToken, ...rest } = mutation.data;

      setAccessTokenToLocalStorage(accessToken);
      setRefreshTokenToLocalStorage(refreshToken);
      dispatch(setUserData(rest));

      proceed(rest.email);
    }
  }, [mutation.isSuccess, mutation.data, dispatch, proceed]);

  return mutation;
};
